import React, { useState, useEffect } from "react";
import { apiFetch, validateFolderAccess  } from "../utils/wkCommon";
import { isZh } from "../utils/language";

export default function FolderFormDialog({
  user,
  folder,
  parentFolder,
  onClose,
  onSaved,
}) {
  const [nameZh, setNameZh] = useState(folder?.name_zh || "");
  const [nameId, setNameId] = useState(folder?.name || "");

  const [accessType, setAccessType] = useState(folder?.access_type || "authenticated");
  const [allowedRoles, setAllowedRoles] = useState(
    folder?.allowed_roles?.map(r => r.id) || []
  );

  const [roles, setRoles] = useState([]);
  const isEdit = Boolean(folder);

  useEffect(() => {
    async function loadRoles() {
      const res = await apiFetch("/api/umat-roles");
      setRoles(res?.data || []);
    }
    loadRoles();
  }, []);  

  function makeSlug(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9\-_.~]/g, "")
      .replace(/-+/g, "-");
  }

  async function save() {
    const payload = {
      name_zh: nameZh,
      name: nameId,
      slug: makeSlug(nameId),
      recordEditor: user?.email || "system",
      access_type: accessType,
      allowed_roles: accessType === "role_based" ? allowedRoles : [],
    };

    if (!isEdit) {
      payload.document_folder = parentFolder?.documentId || null;
      payload.recordOwner = user?.email || "system";
    }

    const check = validateFolderAccess({
      access_type: accessType,
      name: nameId,
      document_folder: parentFolder || folder?.document_folder
    });

    if (check?.warning) {
      alert(check.message);
      return;
    }

    await apiFetch(
      isEdit
        ? `/api/document-folders/${folder.documentId}`
        : "/api/document-folders",
      {
        method: isEdit ? "PUT" : "POST",
        body: { data: payload },
      }
    );

    onSaved();
    onClose();
  }

  return (
    <>
      <style>{`
        .ffd-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.35);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .ffd-dialog {
          background: #fff;
          border-radius: 0.8rem;
          padding: 1.2rem;
          min-width: 28rem;
          max-width: 90%;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }

        .ffd-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .ffd-input {
          width: 95%;
          padding: 0.5rem 0.6rem;
          border-radius: 0.4rem;
          border: 1px solid #ccc;
          margin-bottom: 0.6rem;
          font-size: 0.9rem;
        }

        .ffd-field {
          margin-top: 0.8rem;
          display: flex;
          flex-direction: column;
          gap: 0.3rem;
        }

        .ffd-select {
          padding: 0.4rem;
          border-radius: 0.4rem;
          border: 1px solid #ccc;
        }

        .ffd-actions {
          display: flex;
          justify-content: flex-end;
          gap: 0.5rem;
          margin-top: 1rem;
        }

        .ffd-btn {
          padding: 0.4rem 0.9rem;
          border-radius: 0.4rem;
          border: none;
          cursor: pointer;
        }

        .ffd-btn.primary {
          background: #2f5fa7;
          color: white;
        }

        .ffd-btn.secondary {
          background: #eee;
        }
      `}</style>

      <div className="ffd-overlay" onClick={onClose}>
        <div className="ffd-dialog" onClick={(e)=>e.stopPropagation()}>

          <div className="ffd-title">
            {isEdit
              ? isZh() ? "重新命名資料夾" : "Rename Folder"
              : isZh() ? "新增資料夾" : "New Folder"}
          </div>

          <input
            className="ffd-input"
            placeholder="Chinese Name"
            value={nameZh}
            onChange={(e) => setNameZh(e.target.value)}
          />

          <input
            className="ffd-input"
            placeholder="Nama Indonesia"
            value={nameId}
            onChange={(e) => setNameId(e.target.value)}
          />

          <div className="ffd-field">
            <label>Access Level</label>
            <select
              className="ffd-select"
              value={accessType}
              onChange={(e) => setAccessType(e.target.value)}
            >
              <option value="public">Public</option>
              <option value="authenticated">Authenticated</option>
              <option value="role_based">Role Based</option>
            </select>
          </div>

          {accessType === "role_based" && (
            <div className="ffd-field">
              <label>Allowed Roles</label>
              <select
                multiple
                className="ffd-select"
                value={allowedRoles}
                onChange={(e) => {
                  const vals = Array.from(e.target.selectedOptions).map(o => o.value);
                  setAllowedRoles(vals);
                }}
              >
                {roles.map(r => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="ffd-actions">
            <button className="ffd-btn secondary" onClick={onClose}>
              {isZh() ? "取消" : "Cancel"}
            </button>

            <button
              className="ffd-btn primary"
              disabled={!nameZh || !nameId}
              onClick={save}
            >
              {isZh() ? "儲存" : "Save"}
            </button>
          </div>

        </div>
      </div>
    </>
  );
}
